import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lak_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatEuro = (n) =>
  n == null ? "—" : new Intl.NumberFormat("fi-FI").format(n) + " €";

export const formatKm = (n) =>
  n == null ? "—" : new Intl.NumberFormat("fi-FI").format(n) + " km";
